var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreativeLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35417_24102)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.52223 3.46484C7.08703 3.46484 7.57818 3.85206 7.70998 4.40126L10.4962 16.0106C10.6077 16.4752 10.3215 16.9423 9.85681 17.0538C9.39216 17.1653 8.92509 16.8791 8.81357 16.4144L7.92469 12.7108C7.86977 12.4819 7.66513 12.3206 7.42979 12.3206H2.94194C2.69933 12.3206 2.49045 12.4918 2.44287 12.7297L1.7138 16.3751C1.62008 16.8437 1.16427 17.1475 0.6957 17.0538C0.227134 16.9601 -0.0767445 16.5043 0.0169688 16.0357L2.33476 4.44677C2.44895 3.87582 2.95026 3.46484 3.53252 3.46484H6.52223ZM7.26509 9.96243C7.3419 10.2825 7.09932 10.5902 6.77019 10.5902H3.49161C3.17043 10.5902 2.92955 10.2963 2.99254 9.98139L3.86793 5.60441C3.91551 5.36652 4.12439 5.19528 4.367 5.19528H5.71972C5.95505 5.19528 6.1597 5.35662 6.21462 5.58545L7.26509 9.96243Z",
    fill: "var(--secondary-7)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7551 1.78514C13.7551 1.30729 13.3753 0.919922 12.9068 0.919922C12.4383 0.919922 12.0586 1.30729 12.0586 1.78514V2.44677H10.1822C10.1693 2.44647 10.1565 2.44647 10.1436 2.44677H8.66556C8.59781 2.44677 8.53191 2.45488 8.46875 2.47018C8.91383 2.86175 9.24279 3.38831 9.38894 3.99726L9.43213 4.17721H9.55589C10.0322 5.41383 10.8518 6.57289 11.7159 7.55559C11.2897 7.95786 10.8719 8.31476 10.4966 8.61247L10.9344 10.4366C11.4915 10.0339 12.191 9.46826 12.9068 8.78907C13.7587 9.59735 14.5874 10.2448 15.1806 10.6483C15.5704 10.9133 16.0971 10.8059 16.3569 10.4083C16.6168 10.0107 16.5115 9.47351 16.1217 9.20844C15.608 8.85918 14.8664 8.28119 14.0977 7.55559C14.9618 6.57289 15.7814 5.41383 16.2577 4.17721H17.1481C17.6166 4.17721 17.9963 3.78984 17.9963 3.31199C17.9963 2.83414 17.6166 2.44677 17.1481 2.44677H15.67C15.6571 2.44647 15.6443 2.44647 15.6314 2.44677H13.7551V1.78514ZM14.3945 4.17721H11.4191C11.7921 4.90678 12.3141 5.63357 12.9068 6.31763C13.4995 5.63357 14.0215 4.90678 14.3945 4.17721Z",
    fill: "var(--secondary-4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35417_24102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeLanguage);
export default __webpack_public_path__ + "static/media/creativeLanguage.8b2d46c8f81d645a22b220ab0a638c76.svg";
export { ForwardRef as ReactComponent };